
import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = () => (
    <div className="flex flex-col items-center justify-center h-64">
        <Loader2 className="animate-spin text-blue-600 h-12 w-12" />
        <p className="mt-4">Loading Data...</p>
    </div>
);

export default LoadingSpinner;
